import type { BasedFunctionConfig } from '@based/sdk/functions'

export default {
  type: 'query',
  name: 'list-initiative-recipients',
  public: false,
} as BasedFunctionConfig
